import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
   const errors = {
     localeId: required(get(values, 'localeId'))

  }

  return errors
}

export default validate
